import { Component, Input, HostBinding } from '@angular/core';
import { IWizardSkillData } from '../../models/wizard-skill.model';

@Component({
    selector: 'app-base-component',
    templateUrl: './base.component.html',
    styleUrls: ['./base.component.scss']
})
export class BaseComponent {
    @Input() classes? = undefined;
    @Input() fieldSize = 'medium';
    @Input() data?: IWizardSkillData = {
        label: '',
        payloadKey: '',
        placeholder: ''
    };
    @HostBinding('class') get class() {
        if (this.classes) return this.classes;
    }

    constructor() {}
}
